import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { loading, total, alert, toFixed, format_date, getStorage, replaceText } from "./CustomComponent.js";

import "../assets/css/bootstrap.css";
import "./global.js";

// เรียกปิด loading ทันทีตั้งแต่เข้ามาโหลดหน้า/ไฟล์นี้
loading(false);

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
  FCIconic: {
    normal: "FCIconic-Light.ttf",
    bold: "FCIconic-Bold.ttf",
    italics: "FCIconic-Italic.ttf",
    bolditalics: "FCIconic-Italic.ttf",
  },
  THSarabunNew: {
    normal: "THSarabunNew.ttf",
    bold: "THSarabunNew-Bold.ttf",
    italics: "THSarabunNew-Italic.ttf",
    bolditalics: "THSarabunNew-BoldItalic.ttf",
  },
  Roboto: {
    normal: "Roboto-Regular.ttf",
    bold: "Roboto-Medium.ttf",
    italics: "Roboto-Italic.ttf",
    bolditalics: "Roboto-MediumItalic.ttf",
  },
};

async function print(docDefinition) {
  pdfMake.createPdf(docDefinition).print();
}

async function open(docDefinition, filename = "รายงาน.pdf") {
  try {
    pdfMake.createPdf(docDefinition).open();
  } catch (error) {
    pdfMake.createPdf(docDefinition).download(filename);
    if (error === "Open PDF in new window blocked by browser") {
      alert("warning", "แจ้งเตือน", "ไม่สามารถเปิดเอกสารได้เนื่องจากการปิดกั้นจากบราวเซอร์");
    } else {
      alert("warning", "แจ้งเตือน", "กรุณาลองใหม่อีกครั้ง");
    }
  }
}

// ข้อมูลการแจ้งหนี้และจัดเก็บค่าน้ำ
async function report_bill(data) {
  loading(true); // เปิด loading ระหว่างการประมวลผล PDF
  
  let array = [];
  // Object สำหรับเก็บยอดรวมทั้งหมดในการรัน Loop เพียงครั้งเดียว (ลดการใช้ฟังก์ชัน total ซ้ำซ้อน)
  let t = { water: 0, eq: 0, common: 0, waste: 0, other: 0, debt: 0, meter: 0, late: 0, amount: 0 };

  data.forEach((item, index) => {
    let other = (item.other_income || 0) + (item.fire_cost || 0) + (item.cable_cost || 0);
    let debt = (item.add_debt || 0) - (item.reduce_debt || 0);
    // total_amount จากหน้า Billing รวมค่าปรับชำระล่าช้ามาแล้ว (late_payment = total_cost_late ตัวเดียวกันจาก backend)
    // เดิมบวกค่าปรับซ้ำอีกรอบ ทำให้ "รวมเป็นเงินทั้งสิ้น" ของแต่ละงวดและยอดท้ายใบเกินจริงเท่ากับค่าปรับ
    let totalAmt = item.total_amount || 0;

    // คำนวณยอดรวม (Accumulation) ทันทีในลูปนี้
    t.water += item.water_bill || 0;
    t.eq += item.equipment_maintenance_fee || 0;
    t.common += item.common_expenses || 0;
    t.waste += item.waste_cost || 0;
    t.other += other;
    t.debt += debt;
    t.meter += item.meter_connect_cost || 0;
    t.late += item.total_cost_late || 0;
    t.amount += totalAmt;

    array.push([
      { text: index + 1, alignment: "center", rowSpan: 2 },
      { text: item.full_name || "-", alignment: "left", rowSpan: 2 },
      { text: item.datetime_create ? format_date(item.datetime_create, "dd/mm/yyyy") : "-", alignment: "center" },
      { text: item.current_gauge_number || "0", alignment: "center" },
      { text: item.last_gauge_number || "0", alignment: "center" },
      { text: item.unit_used || "0", alignment: "center" },
      { text: toFixed(item.water_bill || 0), alignment: "right" },
      { text: toFixed(item.equipment_maintenance_fee || 0), alignment: "right" },
      { text: toFixed(item.common_expenses || 0), alignment: "right" },
      { text: toFixed(item.waste_cost || 0), alignment: "right" },
      { text: toFixed(other), alignment: "right" },
      { text: toFixed(debt), alignment: "right" },
      { text: toFixed(item.meter_connect_cost || 0), alignment: "right" },
      { text: toFixed(item.total_cost_late || 0), alignment: "right" },
    ]);

    array.push([
      "", "", { text: "รวมเป็นเงินทั้งสิ้น", alignment: "right", colSpan: 11 }, "", "", "", "", "", "", "", "", "", "", 
      { text: toFixed(totalAmt), alignment: "right" }
    ]);
  });

  const docDefinition = {
    content: [
      { text: getStorage("project_name") || "", alignment: "left", fontSize: 18, bold: true },
      { text: "รายละเอียดค่าน้ำประปาและค่าใช้จ่ายส่วนกลางคงค้าง", alignment: "left", fontSize: 14, bold: true },
      {
        columns: [
          { text: `ห้องเลขที่ ${data[0]?.address_number || "-"} อาคารเลขที่ ${data[0]?.building || "-"}`, alignment: "left", fontSize: 14, bold: true },
          { text: "พิมพ์ ณ. วันที่ " + format_date(new Date(), "DD MMMM YYYY"), alignment: "right", fontSize: 14, bold: true },
        ],
      },
      { text: " " },
      {
        table: {
          headerRows: 1,
          widths: ["4.14%", "11.44%", "8.64%", "7.04%", "7.04%", "5.54%", "7.14%", "7.14%", "7.14%", "6.34%", "7.14%", "6.64%", "6.94%", "7.64%"],
          body: [
            [
              { text: "ลำดับ", alignment: "center" }, { text: "ชื่อ-นามสกุล", alignment: "center" }, { text: "จดมาตร ประจำเดือน", alignment: "center" },
              { text: "เลขมาตร ครั้งนี้", alignment: "center" }, { text: "เลขมาตร ครั้งก่อน", alignment: "center" }, { text: "หน่วยใช้", alignment: "center" },
              { text: "ค่าน้ำ ประปา", alignment: "center" }, { text: "ค่ารักษา อุปกรณ์", alignment: "center" }, { text: "ค่าส่วน กลาง", alignment: "center" },
              { text: "ค่าขยะ", alignment: "center" }, { text: "รายรับ อื่นๆ", alignment: "center" }, { text: "เพิ่ม/ลดหนี้", alignment: "center" },
              { text: "ค่าต่อ มิเตอร์", alignment: "center" }, { text: "ค่าปรับ ชำระล่าช้า", alignment: "center" },
            ],
            ...array,
            [
              { text: "รวมเป็นเงินทั้งสิ้น", alignment: "right", colSpan: 2 }, "", "", "", "", "", 
              { text: toFixed(t.water), alignment: "center" }, { text: toFixed(t.eq), alignment: "center" }, { text: toFixed(t.common), alignment: "center" }, 
              { text: toFixed(t.waste), alignment: "center" }, { text: toFixed(t.other), alignment: "center" }, { text: toFixed(t.debt), alignment: "center" }, 
              { text: toFixed(t.meter), alignment: "center" }, { text: toFixed(t.late), alignment: "center" }
            ],
            [
              { text: "รายละเอียด", alignment: "right", colSpan: 2 }, "", { text: "", colSpan: 9 }, "", "", "", "", "", "", "", "", 
              { text: "รวมเป็นเงิน", alignment: "right", colSpan: 2 }, "", { text: toFixed(t.amount), alignment: "right" }
            ],
          ],
        },
      },
      { text: " " },
      { text: "ผู้จัดพิมพ์รายงาน " + (getStorage("full_name") || "") + " (ธุรการ การเงิน)", alignment: "right", bold: true, fontSize: 14 },
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 11, lineHeight: 1 },
    pageSize: "A4",
    pageMargins: [15, 15, 15, 15],
  };

  let textDocDefinition = await replaceText(docDefinition);
  
  loading(false); // ปิด loading เมื่อสร้างเสร็จ
  
  open(textDocDefinition, "รายละเอียดค่าน้ำประปาและค่าใช้จ่ายส่วนกลางคงค้าง " + new Date().toISOString() + ".pdf");
}

export { report_bill };